import * as React from "react";
import { forwardRef } from "react";
const SvgEnvelope = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", className: "lucide lucide-mail-icon lucide-mail", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "m22 7-8.991 5.727a2 2 0 0 1-2.009 0L2 7" }), /* @__PURE__ */ React.createElement("rect", { x: 2, y: 4, width: 20, height: 16, rx: 2 }));
const ForwardRef = forwardRef(SvgEnvelope);
export default ForwardRef;
